<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <div class="main-menu-container">
      <div class="main-menu-bar full-box">
        <div
          class="nav-category-box"
          @mouseout="navShow=false"
          @mouseover="navShow=true"
        >
          <div class="nav-title">
            <span class="icon"></span>
            <span class="text">产品分类</span>
          </div>
          <div
            class="nav-categoryies"
            v-if="rountePath!=='/'"
            v-show="navShow"
          >
            <CategoryNav></CategoryNav>
          </div>
        </div>
        <div class="nav-list">
          <ul>
            <li>
              <router-link
                to="/"
                exact
              >首页</router-link>
            </li>
            <li>
              <router-link
                class="hot"
                to="/activity"
              ><img
                  class="fire"
                  src="static/img/header/fire.png"
                /> 优选专区</router-link>
            </li>
            <li>
              <router-link to="/agreementProduct">企业集采</router-link>
            </li>
            <li>
              <router-link to="/brand">品牌中心</router-link>
            </li>
            <li>
              <router-link to="/industry">行业方案</router-link>
            </li>
            <li>
              <Dropdown
                @on-click='selectDropItem'
              >
                <a href="javascript:void(0)">
                  智能设备•工业服务
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem
                    :name='item.name'
                    v-for="item in deviceAndService"
                    :key="item.name"
                  >
                    {{item.text}}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </li>
            <li>
              <router-link to="/about">走进鼎阳</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/styles/components/header/mainMenu.scss';
import CategoryNav from '@/components/category/CategoryNav';
const prefix = 'cpt-main-menu';

export default {
  name: 'MmainMenu',
  inject: { reloadBody: 'reloadBody' },
  components: {
    CategoryNav
  },
  data () {
    return {
      prefix,
      rountePath: false,
      navShow: false,
      menuIndex: 0,
      isShop: false,
      deviceAndService: [
        {
          text: '智能设备',
          name: '1'
        },
        {
          text: '工业服务',
          name: '2'
        }
      ]
    };
  },
  methods: {
    sreach () {
      this.$router.push({
        path: '/productlist',
        query: { sreachData: this.sreachData }
      });
    },
    selectDropItem (e) {
      if (this.$route.path.toLowerCase() === '/solution' &&
        this.$route.query.id && this.$route.query.id.toString() === e) {
        this.reloadBody();
      } else {
        this.$router.push({ path: '/solution', query: { id: e } });
      }
    },
    outShopStyle () {
      this.isShop = false;
    },
    selectShopStyle () {
      this.isShop = true;
    }
  },
  created () {
    this.rountePath = this.$route.path;
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/base.scss';
</style>



// WEBPACK FOOTER //
// src/components/header/MainMenu.vue